import React, { useState } from 'react';
import { type GlJeLinesList } from '@store/Finance/Journals/JournalsModels';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { type FormikProps } from 'formik';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';
import CodeCombination from './CodeCombination';
import PopoverCustom from '@components/Shared/Popover/PopoverCustom';
import useConversionRateByLedgard from '@hooks/Finance/DailyRates/useConversionRateByLedgard';
import { NumericFormat } from 'react-number-format';
import useGlChartLookups from '@hooks/Finance/ChartAccountsDetails/useGlChartLookups';

interface formikvalues {
  glDate: string;
  ledgerId: string;
  jeCategory: string;
  jeSource: string;
  periodId: string;
  name: string;
  status: string;
  currencyCode: string;
  conversionFlag: boolean;
  conversionDate: string;
  reverseFlag: boolean;
  jeBatchId: string | null;
  parentJeHeaderId: string | null;
  postedDate: string;
  description: string;
  accountedDr: 0;
  accountedCr: 0;
  JeLinesList: GlJeLinesList[];
}

interface LinesProps {
  formik: FormikProps<formikvalues | any>;
  ledgar?: any;
  isUpdate?: boolean;
  isPosted?: boolean;
}

const JournalLines2: React.FC<LinesProps> = ({ formik, ledgar, isUpdate = false, isPosted = false }) => {
  const { values, setFieldValue } = formik;

  const conversionRate = useConversionRateByLedgard({
    LedgarId: values.ledgerId || '',
    currencyCode: values.currencyCode,
    date: values.glDate
  });

  const { i18n, t } = useTranslation();

  const handleAddLine = (lineType: 'credit' | 'debit') => {
    const newLine = {
      jeLineNum: values.JeLinesList.length + 1,
      enteredDr: 0,
      enteredCr: 0,
      accountDr: '',
      accountCr: '',
      description: '',
      accountId: null,
      companyId: null,
      branchId: null,
      costCenterId: null,
      ///
      lineType: lineType,
      codeCombination: ''
    };
    formik.setFieldValue('JeLinesList', [...formik.values.JeLinesList, newLine]);
  };

  const handleLineChange = (index: number, fieldName: string, value: any) => {
    if (isPosted) return;

    const updatedLines = [...values.JeLinesList];

    const isAmount = fieldName === 'enteredCr' || fieldName === 'enteredDr';

    // ✅ يسمح بالفارغ ليظهر الـ placeholder
    const parsedValue = isAmount ? (value === '' ? '' : Number(value)) : value;

    updatedLines[index] = {
      ...updatedLines[index],
      [fieldName]: parsedValue,

      accountCr:
        fieldName === 'enteredCr'
          ? parsedValue === ''
            ? ''
            : Number(parsedValue) * Number(conversionRate)
          : updatedLines[index].accountCr,

      accountDr:
        fieldName === 'enteredDr'
          ? parsedValue === ''
            ? ''
            : Number(parsedValue) * Number(conversionRate)
          : updatedLines[index].accountDr
    };

    setFieldValue('JeLinesList', updatedLines);
  };

  const handleDeleteLine = (index: number) => {
    if (isPosted) {
      return;
    }
    const updatedLines = values.JeLinesList?.filter((_: any, i: number) => i !== index);
    setFieldValue('JeLinesList', updatedLines);
  };

  //#region CodeCombantion

  const { OptionsCostCenters, OptionsCompanies, OptionsBranches, OptionsAccounts, loading, error } =
    useGlChartLookups();

  const [shawModalAcaount, setShawModalAcaount] = useState(false);
  const [selectedLineIndex, setSelectedLineIndex] = useState<number | null>(null);
  const [accountDetails, setAccountDetails] = useState({
    companyId: '',
    branchId: '',
    costCenterId: '',
    accountId: ''
  });

  const handleAccountClick = (index: number) => {
    if (isPosted) {
      return;
    }
    // if (!values.organizationId) {
    //   SwalAlert({ text: 'حدد الفرع' });
    //   return;
    // }

    const selectedLine = values.JeLinesList[index];
    // إعداد القيم لتمريرها إلى المكون
    const companyId = selectedLine.companyId || '';
    const branchId = selectedLine.branchId || '';
    const accountId = selectedLine.accountId || '';
    const costCenterId = selectedLine.costCenterId || '';

    // تمرير القيم إلى المكون وفتح الـ Modal
    setSelectedLineIndex(index);
    setShawModalAcaount(true);
    setAccountDetails({ accountId, costCenterId, companyId, branchId });
  };
  // const handleAccountSelect = (account: any) => {
  //   if (selectedLineIndex !== null) {
  //     const updatedLines = [...values.JeLinesList];

  //     updatedLines[selectedLineIndex].companyId = account?.company?.id || '';
  //     updatedLines[selectedLineIndex].branchId = account?.branch?.id || '';
  //     updatedLines[selectedLineIndex].costCenterId = account?.costCenter?.id || '';
  //     updatedLines[selectedLineIndex].accountId = account?.account?.id || '';

  //     // var codeCombination = `${account?.company?.accountNumber} | ${account?.branch?.accountNumber} |${account?.costCenter?.accountNumber} |${account?.account?.accountNumber}`;
  //     const codeCombination = [
  //       account?.company?.accountNumber,
  //       account?.branch?.accountNumber,
  //       account?.costCenter?.accountNumber,
  //       account?.account?.accountNumber
  //     ]
  //       .filter(Boolean)
  //       .join('  -  ');

  //     updatedLines[selectedLineIndex].codeCombination = codeCombination || '';

  //     formik.setFieldValue('JeLinesList', updatedLines);
  //   }
  //   setShawModalAcaount(false); // Close modal after selection
  // };

  const handleAccountSelect = (account: any) => {
  if (selectedLineIndex === null) return;

  setFieldValue(`JeLinesList.${selectedLineIndex}.companyId`, account?.company?.id || null);
  setFieldValue(`JeLinesList.${selectedLineIndex}.branchId`, account?.branch?.id || null);
  setFieldValue(`JeLinesList.${selectedLineIndex}.costCenterId`, account?.costCenter?.id || null);
  setFieldValue(`JeLinesList.${selectedLineIndex}.accountId`, account?.account?.id || null);

  setShawModalAcaount(false);
};

  const handleShowAccountDetails = (index: number) => {
    const selectedLine = values.JeLinesList[index];
    const { companyId, branchId, accountId, costCenterId } = selectedLine;

    return (
      <div className='text-start'>
        <p className='m-0'>{OptionsCompanies?.find(f => f.value === companyId)?.accountShow}</p>
        <p className='m-0'>{OptionsBranches?.find(f => f.value === branchId)?.accountShow}</p>
        <p className='m-0'>{OptionsAccounts?.find(f => f.value === accountId)?.accountShow}</p>
        <p className='m-0'>{OptionsCostCenters?.find(f => f.value === costCenterId)?.accountShow}</p>
      </div>
    );
  };
  //#endregion

  //#region Calculate the total debit and credit amounts

  const totalAccountDr = formik.values.JeLinesList?.reduce(
    (total: any, line: any) => Number(total) + Number(line.enteredDr),
    0
  );
  const totalAccountCr = formik.values.JeLinesList?.reduce(
    (total: any, line: any) => Number(total) + Number(line.enteredCr),
    0
  );

  const fmt = (n: any) =>
    Number(n || 0).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

  const buildCodeCombination = (line: any) => {
    const c = OptionsCompanies.find(f => f.value === line.companyId)?.accountNumber;
    const b = OptionsBranches.find(f => f.value === line.branchId)?.accountNumber;
    const cc = OptionsCostCenters.find(f => f.value === line.costCenterId)?.accountNumber;
    const a = OptionsAccounts.find(f => f.value === line.accountId)?.accountNumber;

    return [c, b, cc, a].filter(Boolean).join('  -  ');
  };

  return (
    <>
      <Loading loading={false} error={null} Type='Dots'>
        <>
          <div className='row p-0'>
            <div className='col-12 col-md-6 mb-2'>
              <div className='d-flex text-start'>
                <button
                  disabled={isPosted}
                  type='button'
                  className='btn btn-success  rounded-0 '
                  onClick={() => handleAddLine('credit')}
                >
                  <i className='bi bi-plus-circle fa-lg me-2'></i> {t('إضافة دائن')}
                </button>
                <button
                  disabled={isPosted}
                  type='button'
                  className='btn btn-danger rounded-0 mx-2 '
                  onClick={() => handleAddLine('debit')}
                >
                  <i className='bi bi-dash-circle fa-lg me-2'></i>
                  {t('إضافة مدين')}
                </button>
              </div>
            </div>
            <div className='col-12 col-md-3 mb-2'>
              <div className='rounded-2 p-2 bg-secondary bg-opacity-30'>
                <div className='d-flex justify-content-between'>
                  <div className='fw-bold'>{t('إجمالي الدائن')}:</div>
                  <div className='text-success fs-5 fw-bold'>{fmt(totalAccountCr)}</div>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-3 mb-2'>
              <div className='rounded-2 p-2 bg-secondary bg-opacity-30'>
                <div className='d-flex justify-content-between'>
                  <div className='fw-bold'>{t('إجمالي المدين')}:</div>
                  <div className='text-danger fs-5 fw-bold'>{fmt(totalAccountDr)}</div>
                </div>
              </div>
            </div>
          </div>

          <div className={`table-responsive   text-center `}>
            <table border={1} className='table table-borderless table-hover text-nowrap   mb-0'>
              <thead className='bg-theme bg-opacity-30'>
                {/* <thead className=" "> */}
                <tr>
                  <th className='align-middle  small' style={{ width: '2%' }}>
                    #
                  </th>
                  <th className='align-middle  small' style={{ width: '10%' }}>
                    دائن
                  </th>
                  <th className='align-middle  small' style={{ width: '10%' }}>
                    مدين
                  </th>
                  {/* <th className='align-middle  small' style={{ width: '10%' }}>
                    {Currency?.find((f: any) => f?.currencyCode === ledgar?.currencyCode)?.description}
                  </th> */}

                  <th className='align-middle  small' style={{ width: '46%' }}>
                    {t('الوصف')}
                  </th>

                  <th className='align-middle small' style={{ width: '30%' }}>
                    {t('الحســـاب')}
                  </th>
                  <th className='align-middle text-end' style={{ width: '2%' }}></th>
                </tr>
              </thead>

              <tbody className='fw-bold'>
                {values.JeLinesList?.slice()?.map((line: any, index: any) => {
                  const Index = index;

                  return (
                    <tr key={index}>
                      <td
                        className={`align-middle small  bg-opacity-30 " ${
                          line.lineType === 'credit' ? 'bg-success' : 'bg-danger'
                        }`}
                      >
                        {index + 1}
                      </td>

                      <td className={`align-middle small`}>
                        <NumericFormat
                          value={Number(line.enteredCr || 0) === 0 ? '' : line.enteredCr}
                          placeholder='0.00'
                          thousandSeparator
                          decimalScale={2}
                          fixedDecimalScale
                          allowNegative={false}
                          disabled={isPosted || line.lineType === 'debit'}
                          className='form-control text-center px-0 fw-bold text-success'
                          onValueChange={({ value, floatValue }) => {
                            // value هنا string بدون فواصل
                            handleLineChange(index, 'enteredCr', value === '' ? '' : (floatValue ?? 0));
                          }}
                        />
                      </td>
                      <td className={`align-middle small`}>
                        <NumericFormat
                          value={Number(line.enteredDr || 0) === 0 ? '' : line.enteredDr}
                          placeholder='0.00'
                          thousandSeparator
                          decimalScale={2}
                          fixedDecimalScale
                          allowNegative={false}
                          disabled={isPosted || line.lineType === 'credit'}
                          className='form-control text-center px-0 fw-bold text-danger'
                          onValueChange={({ value, floatValue }) => {
                            handleLineChange(index, 'enteredDr', value === '' ? '' : (floatValue ?? 0));
                          }}
                        />
                      </td>

                      <td className={`align-middle small`}>
                        <Form.Control
                          className={`form-control`}
                          as='textarea'
                          rows={1}
                          value={line.description || ''}
                          onChange={e => handleLineChange(index, 'description', e.target.value)}
                        />
                      </td>

                      <td className='align-middle small'>
                        {line.accountId ? (
                          <PopoverCustom
                            placement='right'
                            childern={
                              <Form.Control
                                readOnly
                                className='form-control text-center'
                                type='text'
                                autoComplete='off'
                                // onChange={() => true}
                                onClick={() => handleAccountClick(index)}
                                // value={line.codeCombination || ''}
                                value={buildCodeCombination(line)}
                              />
                            }
                            Header='تفاصيل الحـــساب'
                            Body={handleShowAccountDetails(index)}
                          />
                        ) : (
                          <Form.Control
                            readOnly
                            className='form-control text-center'
                            type='text'
                            autoComplete='off'
                            // onChange={() => true}
                            onClick={() => handleAccountClick(index)}
                            // value={line.codeCombination || ''}
                            value={buildCodeCombination(line)}
                          />
                        )}
                      </td>

                      <td className='align-middle small'>
                        <button
                          type='button'
                          className='btn btn-outline-danger'
                          onClick={() => handleDeleteLine(Index)}
                        >
                          <i className='fas fa-trash-alt'></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {Array.isArray(formik.errors.JeLinesList) && (
              <div className='bg-danger-subtle p-2 text-danger text-center small fw-bold'>
                {' '}
                {t('يرجى التحقق من صحة بيانات البنود ')}{' '}
              </div>
            )}
          </div>
        </>
      </Loading>

      <NeatixModal
        show={shawModalAcaount}
        setShow={setShawModalAcaount}
        size='md'
        title='الحســــاب'
        headerClassName='bg-theme bg-opacity-25 rounded-top-3 p-2'
        bodyClassName='p-0'
      >
        <div className='p-2'>
          <CodeCombination
            onAccountSelect={handleAccountSelect}
            accountDetails={accountDetails}
            // organizationId={null} // الفرع
          />
        </div>
      </NeatixModal>
    </>
  );
};

export default JournalLines2;
